import { getPrivySessionBridge } from 'features/auth-privy/session-bridge'
import { showNotificationToast } from 'shared/utils/notify'

export const copyAddress = async (address: string) => {
  try {
    await navigator.clipboard.writeText(address)
    showNotificationToast({ type: 'info', title: 'Address copied' })
  } catch {
    showNotificationToast({
      type: 'warning',
      title: 'Could not copy',
      description: address
    })
  }
}

/** Privy only: opens Privy's export modal for the embedded wallet's key (FE-304). */
export const exportPrivyKey = () =>
  getPrivySessionBridge()
    ?.exportWallet()
    .catch(error => {
      console.error('Privy wallet export failed', error)
      showNotificationToast({
        type: 'error',
        title: 'Export unavailable',
        description: 'Only an embedded wallet created by Privy can be exported.'
      })
    })
